import {
  browserLocalPersistence,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth'
import { auth } from './firebaseClient'

let persistenceReady = null

function ensurePersistence() {
  if (!persistenceReady) {
    persistenceReady = setPersistence(auth, browserLocalPersistence)
  }
  return persistenceReady
}

export async function loginWithEmail(email, password) {
  await ensurePersistence()
  const credentials = await signInWithEmailAndPassword(auth, email, password)
  return credentials.user
}

export async function logout() {
  await signOut(auth)
}

export function subscribeToAuthState(callback) {
  return onAuthStateChanged(auth, callback)
}

